module.exports = __webpack_public_path__ + "static/media/bluedeal-vlaanderen-is-water-horizontal.a9a1786d.png";